import React from 'react';
import { CircularProgress } from '@material-ui/core';

const CircularProgressOverlay = ({ loading }) => {
    if (!loading) return null;

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 10, // Ensure it's above the table
            }}
        >
            <CircularProgress color="inherit" size={48} />
        </div>
    );
};

export { CircularProgressOverlay };
